import React from 'react';
import parse from 'html-react-parser';
import QuestionDetailsComponent from './QuestionDetailsComponent';
import { isNullOrUndefined, cloneChoices } from '../Utility/index';

class MultipleChoiceMultipleComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    //  this.textboxChange = _.debounce(this.textboxChange.bind(this), 100);
    this.isChecked = this.isChecked.bind(this);
    this.getAppendText = this.getAppendText.bind(this);
    this.currentChoices = null;
    this.prevLanguageID = null;
    this.state = {
      masterChoices: [], // สำหรับเก็บค่าจากภาษา default
    };
  }

  componentDidMount() {
    const { question } = this.props;

    // เก็บ master choice ที่มี flag ต่างๆ
    this.setState({ masterChoices: question.choices });
  }

  getLocation = (id) => {
    let selectedLocation = '';
    if (Number(id) === 0) {
      selectedLocation = 'Siam Piwat';
    } else if (Number(id) <= 9 && Number(id) !== 0) {
      selectedLocation = 'Siam Paragon';
    } else if (Number(id) > 9 && Number(id) < 16) {
      selectedLocation = 'Siam Center';
    } else if (Number(id) >= 16 && Number(id) <= 21) {
      selectedLocation = 'Siam Discovery';
    } else if (Number(id) > 21 && Number(id) <= 29) {
      selectedLocation = 'ICONSIAM';
    } else {
      selectedLocation = 'ICS';
    }

    return selectedLocation;
  };

  currentAnswerValue() {
    /* define answer model */
    const { question } = this.props;
    let choice_values = question.choices.map((ch) => ({
      elementKey: ch.elementKey,
      choiceText: this.getAppendText(ch),
      checkState: this.isChecked(ch),
    }));
    let new_value = null;
    if (question.includeOther) {
      new_value = {
        isIncludeOther: this.isChecked(question),
        IncludeOtherText: this.getAppendText(question),
        value: choice_values,
      };
    } else {
      new_value = choice_values;
    }

    return new_value;
  }

  componentDidUpdate(prevProps) {
    const { question, currentLanguageID } = this.props;

    if (prevProps.currentLanguageID !== currentLanguageID) {
      // เวลาเปลี่ยนภาษา ให้ inject flag กลับเข้าไป
      const updatedChoices = question.choices.map((choice) => {
        const original = this.state.masterChoices.find(
          (c) => c.elementKey === choice.elementKey,
        );
        return {
          ...choice,
          unselectAllChoices: original?.unselectAllChoices || false,
          isOther: original?.isOther || false,
        };
      });

      // อัปเดต question.choices ให้ใช้ตัวที่มี flag ครบ
      question.choices = updatedChoices;
    }
  }

  handleClick(event, choice) {
    const { question, answer } = this.props;
    let new_value = this.currentAnswerValue();
    if (question.includeOther) {
      if (answer.value.length === 0) {
        if (question.elementKey === choice.elementKey) {
          new_value.isIncludeOther = event.target.checked;
        }
        new_value.value = new_value.value.map((e) => {
          if (choice.elementKey === e.elementKey) {
            e.checkState = event.target.checked;
          }

          return e;
        });
      } else {
        if (question.elementKey === choice.elementKey) {
          new_value.isIncludeOther = event.target.checked;
        }
        new_value.value = new_value.value.map((e) => {
          if (choice.elementKey === e.elementKey) {
            e.checkState = answer.value.reduce((acc, v, i, arr) => {
              if (v.elementKey === e.elementKey) {
                acc = event.target.checked;
              }
              return acc;
            }, true);
          }

          return e;
        });
      }
    } else {
      if (answer.value.length === 0) {
        new_value = new_value.map((e) => {
          if (choice.elementKey === e.elementKey) {
            e.checkState = event.target.checked;
          }

          return e;
        });
      } else {
        new_value = new_value.map((e) => {
          if (choice.elementKey === e.elementKey) {
            e.checkState = answer.value.reduce((acc, v, i, arr) => {
              if (v.elementKey === e.elementKey) {
                acc = event.target.checked;
              }
              return acc;
            }, true);
          }

          return e;
        });
      }
    }
    this.setState({ currentChoices: choice });
    new_value = this.unselectChoices(new_value, choice);
    this.props.setAnswer(this.props, new_value);
  }

  unselectChoices(new_value, choice) {
    const { question } = this.props;

    //set data by includeOther value
    let logVal = new_value;
    if (question.includeOther === true) {
      logVal = new_value.value;
    }
    // dom include other
    const domIncludeOther = document.querySelector(
      `#choice${question.elementKey}`,
    );

    if (
      question.includeOther === true &&
      question.unselectAllChoices === true &&
      new_value.isIncludeOther === true
    ) {
      new_value.value = new_value.value.map((e) => {
        if (e.elementKey !== choice.elementKey) {
          e.checkState = false;
          document.querySelector(`#choice${e.elementKey}`).checked = false;
        } else {
          document.querySelector(`#choice${question.elementKey}`).checked =
            false;
          new_value.isIncludeOther = false;
        }
        return e;
      });
    } else if (
      question.includeOther === true &&
      question.unselectAllChoices === false &&
      new_value.isIncludeOther === true &&
      !logVal.some((e) => e.elementKey === choice.elementKey)
    ) {
      new_value.isIncludeOther = true;
      question.choices.forEach((f) => {
        if (
          f.unselectAllChoices === true &&
          document.querySelector(`#choice${f.elementKey}`).checked === true
        ) {
          document.querySelector(`#choice${f.elementKey}`).checked = false;
        }
      });
    }

    if (
      logVal.some(
        (e) => e.elementKey === choice.elementKey && e.checkState === true,
      )
    ) {
      // check clear other choice
      const elementKeyUncheck = [
        '9370E3A1-A1A4-4A97-9B93-ED6B36A0D2F9',
        'BE95BE2D-C3C4-4A4F-8F61-AF52EBCFFD9F',
        // '44DCB1CB-06C3-4C89-A3E3-3F5C74C2E2C5',
        // flow 1
        // 'ED585F11-4E76-4AA4-8017-DE6941C76B42', // MAIN
        '0027040E-331A-4CD9-B9DF-129AAA09421C', // MAIN
        '45B62DCA-7369-4881-B150-F55E357C54D5', // Siam Center (สยาม เซ็นเตอร์)
        '02796FF2-D129-4176-859C-C25C0670E794', // Siam Discovery (สยาม ดิสคัฟเวอรี่)
        '05C70221-E86C-4E21-A23E-37FED6108223', // Siam Paragon (สยาม พารากอน)
        'CCEBCA36-B05D-4B6B-B267-4511F8CFB371', // Central World (เซ็นทรัลเวิลด์)
        '620C2973-682E-4288-8DC1-D1266FE1FF1D', // Emporium (เอ็มโพเรียม)
        '860EEEFA-3A5D-401D-8AB0-2EEE1AA533CB', // EmQuartier (เอ็มควอเทียร์)
        '4CDF3A47-BEC9-4A96-947E-14B5CF77F010', // EMSPHERE (เอ็มสเฟียร์)
        '64863948-4392-4EAE-8751-E9E33E465489', // Central Chidlom (เซ็นทรัลชิดลม)
        'B3FD0B76-0376-40E0-B08D-2ECE4AB1FDA1', // Central Embassy (เซ็นทรัล เอ็มบาสซี)
        '95AF44C6-D3E4-4EF2-8EC1-201836DB31BE', // Gaysorn Village (เกษรวิลเลจ)
        '7282B2BD-BF9A-482B-ABE1-F95D5BB44AA6', // ICONSIAM (ไอคอนสยาม)
        'BE48CC65-F16B-4019-8F1F-FB25BF8FD342', // ICS (ไอซีเอส)
        '7C1BB3A1-6131-482D-B714-6F85232C927E', // ONE BANGKOK (วัน แบงค็อก)
        '69D3E437-DDB0-48D7-8B6B-F57D58DDA67F', // MegaBangna (เมกาบางนา)
        'CBE025ED-DB24-413F-9F28-4CC806EA58CF', // Central Ladprao (เซ็นทรัลลาดพร้าว)
        '13BEAD5A-216D-41D5-980F-4D766B59C272', // other 1
        '2EB02BE9-3EA4-4091-BF9D-107EA7DE18C6', // other 2
        'AF9B4E8A-7E94-497F-9277-3B3BD4A62CD9', // other 3
        // flow 2
        '9B9D098E-5FAB-4886-820F-A21FA53286E8', // MAIN
        '201FFDA7-26D5-400F-8AD8-A99FE1BF0584', // Siam Center (สยาม เซ็นเตอร์)
        '3EF617AF-3385-4ABF-8E38-A5C0164A8EBE', // Siam Discovery (สยาม ดิสคัฟเวอรี่)
        '6222892F-468E-42ED-9F9C-5CC2B993F7FD', // Siam Paragon (สยาม พารากอน)
        '348A9F22-176B-4DC3-906F-EC0155586930', // Central World (เซ็นทรัลเวิลด์)
        'BFB43548-91FC-4655-97FA-76828E343585', // Emporium (เอ็มโพเรียม)
        '56BE964B-EA27-4B32-8290-F062F4AFFAFE', // EmQuartier (เอ็มควอเทียร์)
        '50C39520-67EC-46A3-B1D5-1E84F9BEE55E', // EMSPHERE (เอ็มสเฟียร์)
        '217D5C94-9080-4DFD-BE43-F2A47F408082', // Central Chidlom (เซ็นทรัลชิดลม)
        '6D55927F-2CDE-49F0-905C-593E0BEE70CD', // Central Embassy (เซ็นทรัล เอ็มบาสซี)
        '269F15B4-ADBC-4C11-826D-DF1384DA2B5E', // Gaysorn Village (เกษรวิลเลจ)
        '62E6C247-48A4-46CE-9E9A-6F5EE95808B9', // ICONSIAM (ไอคอนสยาม)
        'D9B81DEE-542E-4103-8C36-2BF08010E8E0', // ICS (ไอซีเอส)
        '54ED68A9-3518-4A01-B414-C94E284FF712', // ONE BANGKOK (วัน แบงค็อก)
        'CDF49C65-90D2-4DB0-A770-AE8F67E0E38E', // MegaBangna (เมกาบางนา)
        'E49D9B37-37D5-4274-8E07-03E13DE5D134', // Central Ladprao (เซ็นทรัลลาดพร้าว)
        'F6578C83-9A6C-4B0F-AD27-D7B6521CAE8E', // other 1
        '76AF95EE-F25B-400D-80AD-027C3D514833', // other 2
        'CAA0273D-D093-4171-A73C-BDD052698405', // other 3
        // flow 3
        // '79DA2D4C-012D-4A0E-BB03-EA518E02C490', // MAIN
        '2729E7AE-4332-4D59-B956-F5449710DE96', // MAIN
        '2D586D16-F208-41D4-B55A-5A4956D0846C', // Central World
        '05C70221-E86C-4E21-A23E-37FED6108223', // Siam Paragon
        'F334C383-FF64-483B-8392-CF571CDD6AAD', // ONE BANGKOK
        '3FE1E418-88D0-4D19-A7E4-2DBC81BA64CF', // Siam Center
        '4232A713-B9EF-4009-A828-82BCB04BFF47', // Siam Discovery
        '847076EC-01AC-4829-9ADB-4135AE637BBF', // Emporium
        '0C915A1F-EA50-49F2-BF1E-ABE95A282F70', // EmQuartier
        '3504DD82-CC04-48C1-94EC-882DA0D447A3', // EMSPHERE
        'DC4BBE95-F1E9-4EF7-B52B-42001AF48883', // Central Chidlom
        '519A4649-85B9-44F3-9BD5-BB4A5C5B92C9', // Central Embassy
        '1B3161D1-AD2E-4E6E-97C7-A2CE60AEBD7B', // Gaysorn Village
        '6919DCAE-6D18-4216-A1D0-191A8B9EC3B9', // ICONSIAM
        '4067E449-2B8A-4127-A6CF-F3BA42381C3B', // ICS
        'EFDD221D-9DAA-4A14-ABA8-927876AA2755', // MegaBangna
        'AF49B4D7-B744-43B6-B119-8AE24A3839CF', // Central Ladprao
        '267D8AEA-000D-4604-A461-661B4492A8C3', // other 1
        '9F826513-D9F3-4721-9F7C-68730AF6224D', // other 2
        '5B03622E-EF5D-4E2A-A982-3C46CB5D80EF', // other 3
        // 'AD89FFD9-FC32-46E7-963F-2AE24D118684',
        // '9BF4B479-14E8-460C-8475-744E60029A74',
        // '440405BC-C8D5-4DA5-8F69-A031B4025AE8', // en q5.1 neg
        // 'F2CD985A-1AA0-4496-A08B-6298FF30593F', // en q5.1 pos
      ];

      if (elementKeyUncheck.includes(choice.elementKey)) {
        choice.unselectAllChoices = true;
      }
      let log = {};
      if (choice.unselectAllChoices === true) {
        const filteredChoices = this.getFilteredChoices();
        filteredChoices.forEach((element) => {
          const el = document.querySelector(`#choice${element.elementKey}`);
          if (choice.elementKey !== element.elementKey) {
            // ทำอะไรกับ el.checked ตาม logic เดิม
            el.checked = false;
            log = { [element.elementKey]: false, ...log };
          } else {
            log = { [element.elementKey]: true, ...log };
          }
        });
      } else {
        question.choices.forEach((element) => {
          if (
            choice.elementKey !== element.elementKey &&
            element.unselectAllChoices === true
          ) {
            if (document.querySelector(`#choice${element.elementKey}`)) {
              document.querySelector(`#choice${element.elementKey}`).checked =
                false;
            }
            log = { [element.elementKey]: false, ...log };
          }
        });
      }

      if (
        !isNullOrUndefined(domIncludeOther) &&
        choice.unselectAllChoices === true
      ) {
        domIncludeOther.checked = false;
      }
      if (question.includeOther === true) {
        new_value.value = new_value.value.map((g) => {
          if (!isNullOrUndefined(log[g.elementKey]))
            g.checkState = log[g.elementKey];
          return g;
        });
      } else {
        new_value = new_value.map((g) => {
          if (!isNullOrUndefined(log[g.elementKey]))
            g.checkState = log[g.elementKey];
          return g;
        });
      }
      new_value.isIncludeOther = isNullOrUndefined(domIncludeOther)
        ? false
        : domIncludeOther.checked;
    }
    // clear answer include
    if (new_value.isIncludeOther === false) {
      if (document.getElementById(`choicetext${question.elementKey}`)) {
        new_value['IncludeOtherText'] = '';
        document.getElementById(`choicetext${question.elementKey}`).value = '';
      }
    }
    return new_value;
  }
  textboxChange(element, choice) {
    const { question, answer } = this.props;
    let new_value = this.currentAnswerValue();
    if (question.includeOther) {
      if (question.elementKey === choice.elementKey) {
        new_value.IncludeOtherText = element.target.value;
      }
      new_value.isIncludeOther = answer.isIncludeOther;
      new_value.value = new_value.value.map((e) => {
        if (e.elementKey === choice.elementKey) {
          e.choiceText = element.target.value;
        }

        return e;
      });
    } else {
      new_value = new_value.map((e) => {
        if (e.elementKey === choice.elementKey) {
          e.choiceText = element.target.value;
        }

        return e;
      });
    }

    this.props.setAnswer(this.props, new_value);
  }

  getAppendText(choice) {
    const { value } = this.props.answer;

    if (choice.elementKey === this.props.question.elementKey) {
      return this.props.answer.IncludeOtherText;
    }
    if (!Array.isArray(value)) {
      return '';
    } else {
      const ch = value.find((v) => v.elementKey === choice.elementKey);
      if (!ch) {
        return '';
      } else {
        if (ch.checkState) {
          return isNullOrUndefined(ch.choiceText) ? '' : ch.choiceText;
        } else {
          setTimeout(() => {
            const html = document.getElementById(`choicetext${ch.elementKey}`);
            if (html instanceof HTMLTextAreaElement) {
              html.value = ''; // เคลียร์ค่า
            }
          }, 100);
          return (ch.choiceText = '');
        }
      }
    }
  }
  isChecked(choice) {
    const { answer, question } = this.props;
    if (choice.elementKey === question.elementKey) {
      return answer.isIncludeOther;
    }

    if (answer.value.length === 0) {
      return false;
    } else {
      return answer.value.reduce((acc, v, i, arr) => {
        if (v.elementKey === choice.elementKey) {
          acc = v.checkState;
        }
        return acc;
      }, false);
    }
  }

  getFilteredChoices() {
    const { conduct } = this.props;
    let choices = cloneChoices(this.props);

    if (
      conduct.currentNode.elementKey === '3DEBA22D-C2D6-4DB9-8895-50BC217B900D'
    ) {
      choices = choices.filter((c) =>
        conduct?.filterChoicesQ2_1.includes(c.elementKey),
      );
    }

    if (
      conduct.currentNode.elementKey === 'EA04AC7D-D130-46D8-A2FB-942E7146A6C1'
    ) {
      const elementKeysInQ2 = conduct?.filterChoicesQ2.map(
        (item) => Object.keys(item)[0],
      );
      choices = choices.filter((q) => elementKeysInQ2.includes(q.elementKey));
    }

    if (
      conduct.currentNode.elementKey === '10CF8CAA-3DA5-4EA7-B76C-9024311CDB41'
    ) {
      choices = choices.filter(
        (q) => q.elementKey !== conduct.filterChoicesTouristQ6,
      );
    }
    if (
      conduct.currentNode.elementKey === '909D03B1-6042-43D4-BE60-C6A023DD6E89'
    ) {
      choices = choices.filter((c) =>
        conduct?.filterChoicesTouristQ3.includes(c.elementKey),
      );
    }

    return choices;
  }

  render() {
    const { question, currentLanguageID } = this.props;

    const { multipleChoiceDisplayLayout } = question;
    // let choicesCopy = cloneChoices(this.props);
    const choicesCopy = this.getFilteredChoices();

    const choice_group_size =
      multipleChoiceDisplayLayout === 'ONE_COLUMN'
        ? 1
        : multipleChoiceDisplayLayout === 'TWO_COLUMN'
          ? 2
          : 3;

    const choice_groups = choicesCopy.reduce(
      (acc, ch, i) => {
        let group = acc.pop();
        if (group.length === choice_group_size) {
          acc.push(group);
          group = [];
        }
        group.push(ch);
        acc.push(group);
        return acc;
      },
      [[]],
    );

    const placeholderText =
      currentLanguageID === 2
        ? 'Please specify'
        : currentLanguageID === 5
          ? '请注明'
          : 'กรุณาระบุ';

    return (
      <div
        id={`${question.elementKey}`}
        className={`question multiple_choice_multiple_answer`}
      >
        <QuestionDetailsComponent {...this.props} />
        <div className="question_element">
          <div className="choices custom-checkbox">
            {choice_groups.map((g) => (
              <div
                key={g.reduce((acc, v, i, arr) => {
                  acc += v.elementKey;
                  return acc;
                }, 'choice_group')}
                className="choice_group"
              >
                {g.map((ch) => {
                  ch.appendText =
                    ch.elementKey === '9EDB3466-B38B-4661-830E-A73F76A021E7' ||
                    ch.elementKey === 'C80585D0-63DA-475E-BD1E-6B76EA354A5D' ||
                    ch.elementKey === '44DCB1CB-06C3-4C89-A3E3-3F5C74C2E2C5' ||
                    ch.elementKey === '8719F057-AD56-4779-87CD-D6925CF3C74B' ||
                    ch.elementKey === '21C91314-A1B1-4833-9F8C-23C0E36BF559' ||
                    ch.elementKey === 'C5C1CA1D-1EC9-4F92-923E-E3D25FF2EDF1' ||
                    ch.elementKey === 'AD89FFD9-FC32-46E7-963F-2AE24D118684' ||
                    ch.elementKey === '9E395E7C-6D5A-487A-AD49-87430D576EF2' ||
                    ch.elementKey === '30FC3D83-26B6-44C6-AF6C-CFFE63A990F1' ||
                    ch.elementKey === '9BF4B479-14E8-460C-8475-744E60029A74' ||
                    ch.elementKey === '7A3E87B1-D591-4581-8AA2-90E270D7EFFC'
                      ? true
                      : ch.appendText;

                  return (
                    <div key={ch.elementKey} className="choice">
                      <input
                        type="checkbox"
                        id={`choice${ch.elementKey}`}
                        onChange={(e) => {
                          this.handleClick(e, ch);
                        }}
                        defaultChecked={this.isChecked(ch)}
                      />
                      <label>
                        <label
                          htmlFor={`choice${ch.elementKey}`}
                          className="checkmark"
                        />
                        {ch.choiceText ? (
                          <label
                            htmlFor={`choice${ch.elementKey}`}
                            className="choice_content"
                          >
                            {parse(ch.choiceText)}
                          </label>
                        ) : null}
                        {ch.appendText ? (
                          <div className="append_text_wrapper">
                            <textarea
                              className="append_text"
                              placeholder={placeholderText}
                              id={`choicetext${ch.elementKey}`}
                              onBlur={(e) => {
                                e.persist();
                                e.target.value = e.target.value.trim();
                                this.textboxChange(e, ch);
                              }}
                              maxLength="1000"
                              defaultValue={this.getAppendText(ch)}
                            ></textarea>
                          </div>
                        ) : null}
                      </label>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default MultipleChoiceMultipleComponent;
